import { render, staticRenderFns } from "./jdyj.vue?vue&type=template&id=1aa4e5c9&scoped=true&"
import script from "./jdyj.vue?vue&type=script&lang=js&"
export * from "./jdyj.vue?vue&type=script&lang=js&"
import style0 from "./jdyj.vue?vue&type=style&index=0&id=1aa4e5c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa4e5c9",
  null
  
)

export default component.exports